export default __webpack_public_path__ + "static/media/danatoken-right-mobile-bg.2f819f42.png";